import React from "react";
import {
    changeDescOfferModal,
    changePriceOfferModal,
    changeProviderNameInOfferModal
} from "../../../../actions/actionCreators";
import {TextField} from "@material-ui/core";
import i18n from "../../../../i18nextInitiator";
import ButtonWithLoading from "../../ButtonWithLoading";
import {submitPriceFeedback} from "../../../../actions/apiCallActions";
import {connect} from "react-redux";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa','general');
/**
 * maps state to component props.
 * @param state
 */
const mapStateToProps = state => ({ ...state });
/**
 * the price feedback modal which is available in pre invoice page by clicking on it's btn.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PriceFeedbackModal = (props) => {

    const {
        invoice: {
            priceFeedback: {
                provider,
                price,
                description,
                errors: {
                    provider: providerError,
                    price: priceError
                } = {}
            } = {}
        } = {}
    } = props
    return <>
        <TextField
            label={t("provider")}
            onChange={changeProviderNameInOfferModal}
            value={provider}
            placeholder={t("invoice.pre.offer-feedback.provider-placeholder")}
            helperText={providerError ? providerError[0] : t("invoice.pre.offer-feedback.provider-helper")}
            error={providerError}
            fullWidth
        />
        <TextField
            label={t("price")}
            onChange={changePriceOfferModal}
            value={price}
            helperText={priceError ? priceError[0] : t("price-helper-tooman")}
            error={priceError}
            inputProps={{type:"number"}}
            fullWidth
        />
        <TextField
            label={t("more-desc")}
            onChange={changeDescOfferModal}
            value={description}
            helperText={t("optional")}
            fullWidth
            multiline
            rowsMax={3}
        />
        <ButtonWithLoading
            action={submitPriceFeedback}
            size={"large"}
            variant={"contained"}
            color={"primary"}
            fullWidth/>
    </>
}
export default connect(mapStateToProps)(PriceFeedbackModal);
